import React from "react"

import { BannerContainer, BannerText, DataDeletionButton } from "./styled"
import Info from "./assets/u_info-circle.svg"
import segment, { segmentEvents } from "../../../../lib/segment"

const FTCBanner = () => {
  const trackSegment = (link: string) => {
    segment.track(
      segmentEvents.LEGAL_BANNER_CLICKED,
      { link },
      { integrations: { All: false, Heap: true } }
    )
  }

  return (
    <BannerContainer>
      <BannerText>
        <img src={Info} alt="info" width={Info.width} height={Info.height} />
        <DataDeletionButton
          key="sharing-settings"
          onClick={() => {
            /* eslint-disable @typescript-eslint/no-explicit-any */
            ;(window as any).ketch("showPreferences", {
              showOverviewTab: false,
              tab: "consentsTab",
            })
            trackSegment("Data deletion requests")
          }}
        >
          Data deletion requests
        </DataDeletionButton>
      </BannerText>
    </BannerContainer>
  )
}

export default FTCBanner
